import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProcessSuccessful from "../../../assets/icons/ProcessSuccessful";
import SendReceiptModal from "../../Sales/invoice/SendReceiptModal";
import { ICustomer } from "../../../@types";
import { CreateModal } from "../../common/CreateModal";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";

interface RecordPaymentSuccessProps {
  invoiceId?: string;
  handleDownload: (id: string) => void;
  triggerPrint: () => void;
  setSuccess: (success: boolean) => void;
  setShowSendModal: (success: boolean) => void;
  isDownloading: boolean;
  showSendReciept: boolean;
}

const RecordPaymentSuccess = ({
  invoiceId,
  handleDownload,
  setSuccess,
  setShowSendModal,
  triggerPrint,
  isDownloading,
  showSendReciept,
}: RecordPaymentSuccessProps) => {
  const handleSendReceipt = () => {
    setShowSendModal(true);
    setSuccess(false);
  };
  const { t } = useTranslation("invoices");
  const handleDownloadReceipt = () => {
    if (invoiceId) {
      handleDownload(invoiceId);
    } else {
      setSuccess(false);
    }
  };

  return (
    <>
      <CreateModal>
        <div className="w-full md:w-[448px] p-4 bg-white rounded-lg shadow-lg">
          <div className="flex justify-end">
            <div
              onClick={() => setSuccess(false)}
              className="text-red-600 xl:text-[32px] md:text-[28px] text-[24px] cursor-pointer"
            >
              <IoClose />
            </div>
          </div>
          <h1 className="xl:text-[25px] md:text-[22px] text-[20px] font-semibold text-center my-4">
            {t("paymentRecorded")}
          </h1>
          <div className="flex justify-center my-6 sm:h-[116px] h-[90px] ">
            <ProcessSuccessful width="120" height="116" />
          </div>
          <div className="flex flex-col items-center justify-center gap-4 xl:text-[16px] md:text-[15px] text-[14px] font-medium mt-5 text-[#044E97]">
            {showSendReciept && (
              <button
                type="button"
                onClick={handleSendReceipt}
                className="w-[280px] h-[48px] rounded-md text-[#FFFFFF] bg-[#044E97]"
              >
                Send Receipt
              </button>
            )}
            <button
              type="button"
              onClick={triggerPrint}
              className="w-[280px] h-[48px] rounded-md bg-[#FFFFFF] border border-[#044E97] hover:bg-[#ecf5ff]"
            >
              Print Receipt
            </button>
            <button
              type="button"
              onClick={handleDownloadReceipt}
              className="w-[280px] h-[48px] rounded-md text-white bg-[#044E97] hover:bg-[#114274]"
            >
              {isDownloading ? "Downloading..." : "Download Receipt"}
            </button>
          </div>
        </div>
      </CreateModal>
    </>
  );
};

export default RecordPaymentSuccess;
